import React, { useEffect } from 'react';
import { Navbar, Nav, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { Avatar, Dropdown, MenuProps } from 'antd';
import styled from 'styled-components';
import logo from '../../images/logo.svg';
import bell from '../../images/bell.svg';
import noIconProfile from '../../images/iconProfile.svg';
import useToken from '../../hooks/useToken';
import { Chat } from '../Chat/Chat';

const Styles = styled.div`
  a, .navbar-brand, .navbar-nav .nav-link {
      font-size: 14px;
      
      &:hover {
          color: #2196F3;
      }
  }

  #chatNav {
    margin-right: 17px;
  }
  
  // @media (max-width: 766px) {
  //   #chatNav {
  //     margin-right: 0;
  //   }

  //   .navbar-nav .ant-avatar {
  //     display: none;
  //   }
  // }
`

export function ManagerNavbar() {
  const { deleteToken } = useToken();

  const iconProfile = localStorage.getItem('iconProfile') || noIconProfile;

  const items: MenuProps['items'] = [
    {
      label: <Link to="/editProfileManager"> Аккаунт </Link>,
      key: '0',
    },
    {
      label: <Link to="/editProfileCompany"> О компании </Link>,
      key: '1',
    },
    {
      type: 'divider',
    },
    {
      label: 'Выйти',
      key: '3',
      onClick: deleteToken
    },
  ];

  return (
    <Styles>
      <Navbar collapseOnSelect className='justify-content-between' expand="md" bg="white" variant="white">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Brand>
          <Link to="/"> 
            <img src={logo} height="74px" width="115px" className="logo" alt=""/> 
          </Link>
        </Navbar.Brand>
        <Navbar.Collapse id="basic-navbar-nav" >
          <Nav className="me-auto">
            <Nav.Link href="/vacanciesByCompany" id='vacancies'> Вакансии </Nav.Link>
            <Nav.Link href="/candidates" id='candidates'> Кандидаты </Nav.Link>
            {/* <Nav.Link href="/events" id='events'> События </Nav.Link> */}
            <Nav.Link href="/ratingStudents" id='ratingStudents'> Рейтинг студентов </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        {/* <img src={bell} style={{marginRight: '17px', cursor:'pointer'}}/> */}
        <Nav className='d-flex flex-row justify-content-end align-items-center'>
          <div id="chatNav">
            <Chat />
          </div>
          <Dropdown menu={{ items }} trigger={['click']}>
              <Avatar src={iconProfile} style={{cursor:'pointer', height: '30px'}}/>
          </Dropdown>
        </Nav>
      </Navbar>
    </Styles>
  )
}